import {useTranslation} from "react-i18next";
import React, {useCallback, useEffect, useState} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons'
import {usePropState} from "../utils";

function PaginationItem(props) {
  return (
    <li className={`page-item ${props.disabled && 'disabled'}`}>
      <a className="page-link" onClick={props.onClick}>
        {props.children}
      </a>
    </li>
  )
}

function Pagination({ready, ...props}) {
  const { t } = useTranslation();
  const [pageIndex,] = usePropState(props.pageIndex)
  const [pageSize,] = usePropState(props.pageSize)
  const [pageCount,] = usePropState(props.pageCount)
  const [totalSize,] = usePropState(props.totalSize)
  const [canNextPage,] = usePropState(props.canNextPage)
  const [canPreviousPage,] = usePropState(props.canPreviousPage)
  const [pages, setPages] = useState([])
  const [show, setShow] = useState(false)

  const nextPage = useCallback(() => {
    props.nextPage();
  }, [props.nextPage])

  const previousPage = useCallback(() => {
    props.previousPage();
  }, [props.previousPage])

  const gotoPage = useCallback((val) => {
    props.gotoPage(val);
  }, [props.gotoPage])

  useEffect(() => {
    setPages([1, ...(pageIndex <= 3 ? [2, 3] : []), pageCount, pageIndex - 1, pageIndex, pageIndex + 1].sort((a,b) =>
      a - b
    ).filter(x =>
      (x>=1 && x<=pageCount)
    ).filter((value, index, self) =>
      (self.indexOf(value)===index)
    ))
  }, [pageIndex, pageCount])

  useEffect(() => {
    setShow(pageCount > 1)
  }, [pageCount])

  return (
    <>
      {ready && show && <div className="row" style={{marginTop: "30px"}}>
        <div className="col-sm-12 col-md-6">
          <div className="dataTables_info">
            {t('table.elementsCount', {
              firstElement: (pageIndex - 1) * pageSize + 1,
              lastElement: Math.min(pageIndex * pageSize, totalSize),
              totalElements: totalSize
            })}
          </div>
        </div>
        <div className="col-sm-12 col-md-6">
           <div className="dataTables_paginate paging_full_numbers" style={{display: "flex", justifyContent: "flex-end"}}>
            <ul className="pagination" style={{marginBottom: 0}}>
              <PaginationItem disabled={!canPreviousPage} onClick={() => previousPage()} key='prev'>
                <FontAwesomeIcon icon={faAngleLeft} />
              </PaginationItem>
              {
                pages.map((page, i) => (
                    <React.Fragment key={page}>
                      {i > 0 && pages[i] - 1 - pages[i - 1] > 1 && <PaginationItem disabled={true} key={page - 1}>
                        …
                      </PaginationItem>}
                      {i > 0 && pages[i] - 1 - pages[i - 1] == 1 && <PaginationItem disabled={false} key={page - 1}>
                        {page - 1}
                      </PaginationItem>}
                      <PaginationItem disabled={page == pageIndex} onClick={() => gotoPage(page - 1)} key={page}>
                        {page}
                      </PaginationItem>
                    </React.Fragment>
                  )
                )
              }
              <PaginationItem disabled={!canNextPage} onClick={() => nextPage()} key='next'>
                <FontAwesomeIcon icon={faAngleRight} />
              </PaginationItem>
            </ul>
          </div>
        </div>
      </div>}
    </>
  )
}

export default Pagination
